<div class="container">

    <shopcart [checkoutClicked]="true">
    </shopcart>

    <custship></custship>

    <!--<form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()" class="ui form">
    <div class="row">
        <div class="col-md-12">Shipping Information</div>
    </div>
    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-6"></div>
        <div class="col-xs-12 col-sm-6 col-md-6"></div>
    </div>
    <div class="row">
        <div class="col-md-12">Payment Information</div>
    </div>
    <div class="row">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="col-xs-12 col-sm-12 col-md-12">
                    <label for="paymentType">Payment Type*</label><br/>
                        <div *ngFor='let payment of payments'>
                            <label><input type="radio" formControlName="paymentType" (change)="setRadioControl()" [checked]="payment.value === 'CC'" [value]="payment.value">{{payment.display}}</label>
                        </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12"  *ngIf="setRadioControl() === 'ACH'">
                <div class="form-group col-md-6 col-sm-6">
                        <label for="routing">Routing Number*</label>
                        <input (blur)="checkRouting()" formControlName="custRouting" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="checkoutForm.controls['custRouting'].hasError('required') && checkoutForm.controls['custRouting'].touched" class="alert alert-danger">A valid routing number is required.</div>

                    </div>

                    <div class="form-group col-md-6 col-sm-6">
                        <label for="acct">Account Number*</label>
                        <input formControlName="custAccountNum" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="achGood == false && checkoutForm.controls['custAccountNum'].touched"
                            class="alert alert-danger">{{achErrorMessage}}</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="name">Account Name</label>
                        <input formControlName="custAccountName" class="form-control input-sm">
                        <div *ngIf="checkoutForm.controls['custAccountName'].hasError('required') && checkoutForm.controls['custAccountName'].touched"
                            class="alert alert-danger">The name on the account is required.</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="type">Account Type*</label>
                        <select formControlName="custAccountType" class="form-control input-sm">
                        <option *ngFor="let acct of accountType">{{acct.display}}</option>
                    </select>
                        <div *ngIf="checkoutForm.controls['custAccountType'].hasError('required') && checkoutForm.controls['custAccountType'].touched"
                            class="alert alert-danger">A account type is required.</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="amt">Amount to be Charged</label><br/>
                        <label>{{amountToPay() | currency:'USD':true:'1.2-2'}}</label>
                    </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12" *ngIf="setRadioControl() === 'CC'">
                 <div class="form-group col-md-6 col-sm-6">
                        <label for="firstname">First Name on Card*</label>
                        <input formControlName="custFirst" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="checkoutForm.controls['custFirst'].hasError('required') && checkoutForm.controls['custFirst'].touched" class="alert alert-danger">First name is required.</div>

                    </div>

                    <div class="form-group col-md-6 col-sm-6">
                        <label for="lastname">Last Name on Card*</label>
                        <input formControlName="custLast" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="checkoutForm.controls['custLast'].hasError('required') && checkoutForm.controls['custLast'].touched" class="alert alert-danger">Last name is required.</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="address">Bill Street*</label>
                        <input formControlName="custStreet" class="form-control input-sm">
                        <div *ngIf="checkoutForm.controls['custStreet'].hasError('required') && checkoutForm.controls['custStreet'].touched" class="alert alert-danger">Bill street is required.</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="pincode">Zip Code*</label>
                        <input formControlName="custZip" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="checkoutForm.controls['custZip'].hasError('required') && checkoutForm.controls['custZip'].touched" class="alert alert-danger">A valid zip code is required.</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="email">Card Number*</label>
                        <input (blur)="checkCC()" formControlName="custCard" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="ccGood==false && checkoutForm.controls['custCard'].touched" class="alert alert-danger">{{ccErrorMessage}}</div>

                    </div>

                    <div class="form-group col-md-6 col-sm-6">
                        <label for="city">Exp Month*</label>
                        <select formControlName="custExpMonth" class="form-control input-sm">
                        <option *ngFor="let month of months">{{month}}</option>
                    </select>
                        <div *ngIf="checkoutForm.controls['custExpMonth'].hasError('required') && checkoutForm.controls['custExpMonth'].touched"
                            class="alert alert-danger">Valid expiration month is required.</div>

                        <input formControlName="custExpMonth" type="date" class="form-control input-sm" placeholder="">
                    </div>

                    <div class="form-group col-md-6 col-sm-6">
                        <label for="state">Exp Year*</label>
                        <select formControlName="custExpYear" class="form-control input-sm">
                        <option *ngFor="let year of years">{{year}}</option>
                    </select>
                        <div *ngIf="checkoutForm.controls['custExpYear'].hasError('required') && checkoutForm.controls['custExpYear'].touched" class="alert alert-danger">Valid expiration year is required.</div>

                    </div>

                    <div class="form-group col-md-6 col-sm-6">
                        <label for="country">Security Code</label>
                        <input formControlName="custCvv" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="checkoutForm.controls['custCvv'].hasError('required') && checkoutForm.controls['custCvv'].touched" class="alert alert-danger">A valid security code is required.</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="amt">Amount to be Charged</label><br/>
                        <label>{{amountToPay() | currency:'USD':true:'1.2-2'}}</label>
                    </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12">
                <button type="submit" class='btn btn-primary'>Process Order</button>
            </div>
    </div>
</form>
-->

    <NuveiPaymentsComponent></NuveiPaymentsComponent>

    <!-- <div class="inventory-cart-checkout">
        <br/>
        <h3><i class="fa fa-credit-card-alt" aria-hidden="true"></i> &nbsp;Payment Information</h3>
        <hr/>
        <br/>
        <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()" class="ui form">
            <div class="col-md-12 col-sm-12">
                <label for="paymentType">Credit Card*</label><br/>

                   <div class="form-group col-md-6 col-sm-6">
                        <label for="firstname">First Name on Card*</label>
                        <input placeholder="First Name on Card"  formControlName="custFirst" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="checkoutForm.controls['custFirst'].hasError('required') && checkoutForm.controls['custFirst'].touched" class="alert alert-danger">First name is required.</div>

                    </div>

                    <div class="form-group col-md-6 col-sm-6">
                        <label for="lastname">Last Name on Card*</label>
                        <input placeholder="Last Name on Card"  formControlName="custLast" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="checkoutForm.controls['custLast'].hasError('required') && checkoutForm.controls['custLast'].touched" class="alert alert-danger">Last name is required.</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="address">Bill Street*</label>
                        <input placeholder="Bill Street" formControlName="custStreet" type="text" class="form-control input-sm">
                        <div *ngIf="checkoutForm.controls['custStreet'].hasError('required') && checkoutForm.controls['custStreet'].touched" class="alert alert-danger">Bill street is required.</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="pincode">Zip Code*</label>
                        <input placeholder="Zip Code" formControlName="custZip" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="checkoutForm.controls['custZip'].hasError('required') && checkoutForm.controls['custZip'].touched" class="alert alert-danger">A valid zip code is required.</div>

                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="cardType">Card Type*</label>
                        <select placeholder="Card Type" formControlName="cardType" 
                            class="form-control input-lg" placeholder="">
                            <option>Discover</option>
                            <option>MasterCard</option>
                            <option>Visa</option>                              
                        </select>    
                        <div *ngIf="checkoutForm.controls['cardType'].hasError('required') && checkoutForm.controls['cardType'].touched"
                        class="alert alert-danger">Valid card type is required.</div>
                    </div>
                    <div class="form-group col-md-6 col-sm-6">
                        <label for="email">Card Number*</label>
                        <input placeholder="Card Number" (blur)="checkCC()" formControlName="custCard" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="ccGood==false && checkoutForm.controls['custCard'].touched" class="alert alert-danger">{{ccErrorMessage}}</div>

                    </div>

                    <div class="form-group col-md-6 col-sm-6">
                        <label for="city">Exp Month*</label>
                        <select formControlName="custExpMonth" class="form-control input-lg">
                        <option *ngFor="let month of months">{{month}}</option>
                    </select>
                        <div *ngIf="checkoutForm.controls['custExpMonth'].hasError('required') && checkoutForm.controls['custExpMonth'].touched"
                            class="alert alert-danger">Valid expiration month is required.</div>

                    </div>

                    <div class="form-group col-md-6 col-sm-6">
                        <label for="state">Exp Year*</label>
                        <select formControlName="custExpYear" class="form-control input-lg">
                        <option *ngFor="let year of years">{{year}}</option>
                    </select>

                    </div>

                    <div class="form-group col-md-6 col-sm-6">
                        <label for="country">Security Code</label>
                        <input placeholder="Security Code (CCV)" formControlName="custCvv" type="text" class="form-control input-sm" placeholder="">
                        <div *ngIf="checkoutForm.controls['custCvv'].hasError('required') && checkoutForm.controls['custCvv'].touched" class="alert alert-danger">A valid security code is required.</div>

                    </div>
                    
                    
                <div class="form-group col-md-12 col-sm-12 inventory-checkout-total">
                        <br/>
                        <hr/>
                        <br/>
                        <div class="inventory-checkout-total-ammount aright"><label for="amt">Amount to be Charged:</label>&nbsp;<label>{{amountToPay() | currency:'USD':true:'1.2-2'}}</label></div>
                        <br/>
                        <hr/>
                        <br/>
                        <div class="inventory-checkout-total-ammount-proccess aright"><button type="submit" name="submitButton" #submitButton class='btn btn-primary btn-main btn-block' >Process Order</button></div>
                    </div>
                
            </div>
            
        </form>        
</div> -->